import { render, staticRenderFns } from "./MatterAppealInfoForm.vue?vue&type=template&id=157de7b5&"
import script from "./MatterAppealInfoForm.vue?vue&type=script&lang=js&"
export * from "./MatterAppealInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterAppealInfoForm.vue?vue&type=style&index=0&id=157de7b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports